<!-- google-map-demo.component.html -->
<ng-template #Addresspopup let-model>
  <div class="modal-header" [ngStyle]="{
        'justify-content': 'right',
        height: '40px',
        backgroundColor:
          (Merchant$ | async)?.webapp_settings?.menu_color ||
          (Merchant$ | async)?.menu_color,
        'border-bottom':
          (Merchant$ | async)?.webapp_settings?.menu_border_width +
          'px solid ' +
          (Merchant$ | async)?.webapp_settings?.menu_border_color,
      }">
    <a (click)="model.close()" id="btnnotification" class="close-icon">
      <i [ngStyle]="{
                color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
              }" class="zmdi zmdi-close zmdi-hc-fw"></i>
    </a>
  </div>
  @if (IsMap) {
    <div>
      <div class="modal-body">
        @if (IsMap) {
        <div id="mapBox">
            <google-map width="100%" height="550px" [center]="center" [zoom]="zoom" (mapClick)="addMarker($event)">
              <map-marker (mapDragend)="dragMarker($event)" [position]="markerPosition" [options]="markerOptions">
              </map-marker>
            </google-map>
            </div>
            }
            </div>
      <div class="modal-footer" [ngStyle]="{ display: 'block' }">
        <div class="d-grid">
          <button type="button" class="btn btn-accent-theme btn-lg mt-2" [ngStyle]="{
                        color: (Merchant$ | async)?.webapp_settings
                          ?.menu_font_color_homepgae,
                        backgroundColor:
                          (Merchant$ | async)?.webapp_settings?.menu_color ||
                          (Merchant$ | async)?.menu_color,
                        border:
                          (Merchant$ | async)?.webapp_settings?.menu_border_width +
                          'px solid ' +
                          (Merchant$ | async)?.webapp_settings?.menu_border_color,
                      }" (click)="IsMap = false">
            Next
          </button>
          </div>
          </div>
          <!-- <div class="modal-footer row row-cols-2">
        <div class="col m-0 d-grid">
          
        </div>
        <div class="col m-0 d-grid">
          <button type="button"
            [ngStyle]="{'color':(Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,'backgroundColor':(Merchant$ | async)?.webapp_settings?.menu_color,'border' :(Merchant$ | async)?.webapp_settings?.menu_border_width +
'px solid ' + (Merchant$ | async)?.webapp_settings?.menu_border_color}"
            class="btn btn-orange-light-theme btn-lg font-size-15" (click)="IsMap = false;">Next</button>
        </div>
      </div> 
    </div> -->
    </div>
  }

  @if (!IsMap) {
    <div class="p-4">
      <form #AddressForm="ngForm" (ngSubmit)="AddAddress(AddressForm)" novalidate>
        <div class="row row-cols-2">
          <div class="col-12">
            <div class="form-group">
              <input type="text" name="AddressName" required [(ngModel)]="Address.name" #model="ngModel"
                class="form-control form-control-lg" placeholder="Address Name (home,office etc..)" />
              @if (
              AddressForm.controls["AddressName"]?.invalid &&
              (AddressForm.controls["AddressName"].dirty ||
              AddressForm.controls["AddressName"].touched)
              ) {
              <div>
                  @if (AddressForm.controls["AddressName"].errors.required) {
                  <span [ngStyle]="{
                                          color: (Merchant$ | async)?.webapp_settings
                                            ?.menu_font_color_allpage,
                                        }">
                    please enter Address Name
                  </span>
                  }
                  </div>
                  }
                  </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
              <input type="text" name="Address1" required [(ngModel)]="Address.line_1" class="form-control form-control-lg"
                placeholder="Address Line1" />
              @if (
              AddressForm.controls["Address1"]?.invalid &&
              (AddressForm.controls["Address1"].dirty ||
              AddressForm.controls["Address1"].touched)
              ) {
              <div>
                  @if (AddressForm.controls["Address1"].errors.required) {
                  <span [ngStyle]="{
                                          color: (Merchant$ | async)?.webapp_settings
                                            ?.menu_font_color_allpage,
                                        }">
                    please enter Address Line1
                  </span>
                  }
                  </div>
                  }
                  </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
              <input type="text" name="Address2" [(ngModel)]="Address.line_2" class="form-control form-control-lg"
                placeholder="Address Line2" />
              </div>
              </div>
              <div class="col-12">
                <div class="form-group">
              <ng-select class="ng-select-md" (change)="countrychange($event)" bindLabel="name" bindValue="id" name="ddlcountry"
                required [items]="Country" [(ngModel)]="selectedCountry" placeholder="-- Select Country --">
              </ng-select>
              @if (
              AddressForm.controls["ddlcountry"]?.invalid &&
              (AddressForm.controls["ddlcountry"].dirty ||
              AddressForm.controls["ddlcountry"].touched)
              ) {
              <div>
                  @if (AddressForm.controls["ddlcountry"].errors.required) {
                  <span [ngStyle]="{
                                          color: (Merchant$ | async)?.webapp_settings
                                            ?.menu_font_color_allpage,
                                        }">
                    please select Country
                  </span>
                  }
                  </div>
                  }
                  </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
              <ng-select class="ng-select-md" bindLabel="name" bindValue="id" (change)="citychange($event)" name="ddlcity" required
                [items]="City" [(ngModel)]="selectedCity" placeholder="-- Select City --">
              </ng-select>
              @if (
              AddressForm.controls["ddlcity"]?.invalid &&
              (AddressForm.controls["ddlcity"].dirty ||
              AddressForm.controls["ddlcity"].touched)
              ) {
              <div>
                  @if (AddressForm.controls["ddlcity"].errors.required) {
                  <span [ngStyle]="{
                                          color: (Merchant$ | async)?.webapp_settings
                                            ?.menu_font_color_allpage,
                                        }">
                    please select City
                  </span>
                  }
                  </div>
                  }
                  </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
              <ng-select class="ng-select-md" bindLabel="name" name="ddldistrict" bindValue="id" required [items]="District"
                [(ngModel)]="selectedDistrict" placeholder="-- Select District --">
              </ng-select>
              @if (
              AddressForm.controls["ddldistrict"]?.invalid &&
              (AddressForm.controls["ddldistrict"].dirty ||
              AddressForm.controls["ddldistrict"].touched)
              ) {
              <div>
                  @if (AddressForm.controls["ddldistrict"].errors.required) {
                  <span [ngStyle]="{
                                          color: (Merchant$ | async)?.webapp_settings
                                            ?.menu_font_color_allpage,
                                        }">
                    please select district
                  </span>
                  }
                  </div>
                  }
                  </div>
                  </div>
                  <div class="col">
                    <div class="form-group">
                      <!-- old code -->
                      <!-- <input type="text" name="postcode" required [(ngModel)]="Address.postcode" class="form-control form-control-lg" placeholder="Post Code"> -->
              <input type="text" name="postcode" [(ngModel)]="Address.postcode" class="form-control form-control-lg"
                placeholder="Post Code" />
              </div>
              </div>
              <div class="col">
                <div class="form-group">
              <input type="text" name="coordinate" required disabled [(ngModel)]="Address.coordinate"
                class="form-control form-control-lg" placeholder="coordinate" />
              </div>
              </div>
              </div>
              <div class="modal-footer row row-cols-2">
                <div class="col m-0 d-grid">
            <button type="button" [ngStyle]="{
                            color: (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae,
                            backgroundColor: (Merchant$ | async)?.webapp_settings
                              ?.menu_color,
                            border:
                              (Merchant$ | async)?.webapp_settings?.menu_border_width +
                              'px solid ' +
                              (Merchant$ | async)?.webapp_settings?.menu_border_color,
                          }" class="btn btn-orange-light-theme btn-lg font-size-15" (click)="IsMap = true">
              back
            </button>
            </div>
            <div class="col m-0 d-grid">
              <!-- (click)="modal.close('Close click')" -->
            <button type="button" [ngStyle]="{
                            color: (Merchant$ | async)?.webapp_settings
                              ?.menu_font_color_homepgae,
                            backgroundColor: (Merchant$ | async)?.webapp_settings
                              ?.menu_color,
                            border:
                              (Merchant$ | async)?.webapp_settings?.menu_border_width +
                              'px solid ' +
                              (Merchant$ | async)?.webapp_settings?.menu_border_color,
                          }" class="btn btn-orange-light-theme btn-lg font-size-15" [disabled]="!AddressForm.valid"
              (click)="AddAddress(AddressForm)">
              submit
            </button>
            </div>
            </div>
            </form>
            </div>
  }
</ng-template>
